var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TrellisModal',{attrs:{"title":"Web Login","persistent":""},on:{"close":_vm.onClose},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('LoginForm',{on:{"login":_vm.done}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }